/* Pattern for ad hoc query against relay store */
import graphql from 'babel-plugin-relay/macro';
import { fetchQuery } from 'react-relay';
import AbEnvironment from '../auth/AbEnvironment';

const abEnvironment = new AbEnvironment();
    
const query = graphql`
query PartnerFetchQuery($vendorAccountId: UUID!) {
  accountTByAccountId(accountId: $vendorAccountId) {
    accountRelationTsByAccountId (condition: {relationType: 0}) {
      nodes {
        relatedId
        accountTByRelatedId {
          accountName
        }
      }
    }
  }
}
`;

function fetch(vendorAccountId) {
const variables = {
  vendorAccountId: vendorAccountId
}

return fetchQuery(
    abEnvironment.getEnvironment(),
    query,
    variables
);
}
/* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */  
export default { fetch };
